var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {},

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function ($rowElem) {
                var rowId = $rowElem.data('estimationid');
                return {id: rowId, el: $rowElem};
            },
            actions: [{
                name: 'Tabelle neu laden',
                classNames: 'dropdown-item',
                iconClass: 'bi-arrow-repeat',
                onClick: this.onReload,
            }, {
                name: 'Einheiten importieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-box-arrow-in-down',
                onClick: this.onImportKeyNumbers,
            // }, {
            //     name: 'Löschen',
            //     classNames: 'dropdown-item text-danger',
            //     iconClass: 'bi-trash text-danger',
            //     onClick: this.onDelete,
            //     isShown: (row) => row.el.is('[data-workid!=""]'),
            }],
        });
    },

    events: [{
        name: 'click',
        el(component) {
            return component.el.querySelectorAll('.btn-context-click');
        },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        onReload(row) {
            estimation.loadEstimation();
        },
        onImportKeyNumbers(row) {
            slidein.openUrl('/ProjectEstimation/ImportKeyNumbersSlideIn/' + row.id, function (element) {
                //
            });
        },
    },

}
